import { useCallback } from 'react';
import { useRxData } from 'rxdb-hooks';

import { RxdbCollectionName } from '../rxdbCollectionName';
import type {
  OperationalDowntime,
  OperationalDowntimeCollection,
} from './operationalDowntime.types';

const useOperationalDowntime = () => {
  const getOperationalDowntimeQuery = useCallback(
    (collection: OperationalDowntimeCollection) => collection?.find(),
    [],
  );

  const { result: operationalDowntimeListData } = useRxData<OperationalDowntime>(
    RxdbCollectionName.OPERATIONAL_DOWNTIME,
    getOperationalDowntimeQuery,
    { json: true },
  );

  return { operationalDowntimeListData };
};

export default useOperationalDowntime;
